<template>
  <div class="logo-description">
    <div class="logo">
      <router-link :to="{name: 'home'}">
        <img src="amej-pay.png" />
      </router-link>
    </div>
    <div class="description">
      <p>{{ data.title }}</p>
      <span>{{ data.subtitle }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "LogoDescription",

  props: ["data", "published"],
};
</script>
<style scoped>
.logo-description {
  display: grid;
  place-items: center;
  margin-bottom: 33px;
  margin-right: 0px;
  margin-left: 0px;
}
.logo-description p {
  font-size: 24px;
}
.logo-description span {
  font-size: 16px;
}
.logo-description .logo {
  height: 44px;
  width: 80px;
  margin-top: 2em;
}
.logo-description .logo img {
  height: 100%;
  width: 100%;
}
.logo-description .description {
  display: contents;
}

.logo-description .description a {
  font-size: 14px;
}
</style>